/**
 * Ryan O'Dowd
 * 2025-01-12
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Dialog as PaperDialog,
} from 'react-native-paper';
import React from 'react';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const Actions = (props: ActionsProps & React.ComponentProps<typeof PaperDialog.Actions>) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <PaperDialog.Actions
      {...props}
      style={[styles.container, props.style]}
    >
      <View style={styles.errorMessageAndButtonsWrapper}>
        {!!props.errorMessage && <Text style={styles.errorMessageText}>{props.errorMessage}</Text>}
        <View style={styles.buttonsWrapper}>
          {React.Children.map(props.children, (child, index) => {
            if (!React.isValidElement(child)) {
              return child;
            }

            return React.cloneElement(
              child,
              {
                key: child.key ?? index,
                uppercase: (child.props as any)?.uppercase ?? false,
                compact: (child.props as any)?.compact ?? true,
              } as any,
            );
          })}
        </View>
      </View>
    </PaperDialog.Actions>
  );
};

class ActionsProps {
  errorMessage?: string;
};

export default Actions;
